import React from 'react';
import { useTranslation } from 'react-i18next';
import { SECTION_TITLES } from '../../../../constants/BookingViewConstants';
import BookingSlotDetailRow from './BookingSlotDetailRow';
import { SlotSectionTitle } from './BookingView.styles';
import { SlotDetail } from './BookingView.types';

interface BookingSlotDetailsSectionProps {
  slots: SlotDetail[];
  isContextual: boolean;
}

const BookingSlotDetailsSection: React.FC<BookingSlotDetailsSectionProps> = ({
  slots,
  isContextual,
}) => {
  const { t } = useTranslation();

  const titleKey = isContextual
    ? SECTION_TITLES.CONTEXTUAL
    : SECTION_TITLES.NON_CONTEXTUAL;

  return (
    <>
      <SlotSectionTitle>{t(titleKey)}</SlotSectionTitle>
      {slots.map((slot) => (
        <BookingSlotDetailRow
          key={slot.contextualNode}
          slot={slot}
          isContextual={isContextual}
        />
      ))}
    </>
  );
};

export default BookingSlotDetailsSection;
